module.exports = __webpack_public_path__ + "static/media/ricardo.fd68d469.jpg";